import Button from 'components/actions/Button';
import Dialog from 'components/overlays/Dialog';

interface FooterProps {
    id: string;
    onConfirm: () => void;
    onCancel: () => void;
    isLoading?: boolean;
}

const Footer = ({ id, onConfirm, onCancel }: FooterProps) => (
    <div className='display-flex justify-content-end gap-10'>
        <Button data-testid={`system-admin-dialog-form-cancel-btn-${id}`} onClick={onCancel}>
            No, back to editing
        </Button>
        <Button
            className='btn btn-danger'
            data-testid={`system-admin-dialog-form-cancel-btn-${id}`}
            onClick={onConfirm}
        >
            Yes, cancel
        </Button>
    </div>
);

interface Props {
    id: string;
    show: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const ExitEditingDialog = ({ id, show, onConfirm, onCancel }: Props) => (
    <Dialog
        data-testid={`system-admin-confirm-dialog-${id}`}
        show={show}
        title='Are you sure you want to cancel?'
        size='sm'
        footer={<Footer id={id} onCancel={onCancel} onConfirm={onConfirm} />}
        body={
            <p className='ExitEditingDialog__message'>
                Your changes will be lost and we won’t be able to recover your inputs.
            </p>
        }
        onClose={onCancel}
        showCloseButton
    />
);

export default ExitEditingDialog;
